import classnames from "classnames";
import PropTypes from "prop-types";

import { SIZES } from "./constants";
import "./scrollable.scss";

const Scrollable = ({
  children,
  className = "",
  size = "small",
  ...otherProps
}) => (
  <div
    className={classnames([
      "neeto-molecules-scrollable",
      {
        "neeto-molecules-scrollable--nano": size === SIZES.nano,
        "neeto-molecules-scrollable--small": size === SIZES.small,
        "neeto-molecules-scrollable--medium": size === SIZES.medium,
        "neeto-molecules-scrollable--large": size === SIZES.large,
        "neeto-molecules-scrollable--viewport": size === SIZES.viewport,
        [className]: className,
      },
    ])}
    {...otherProps}
  >
    {children}
  </div>
);

Scrollable.propTypes = {
  /**
   * To specify the components to be rendered inside the Scrollable.
   */
  children: PropTypes.node,
  /**
   * To specify vertical size of the Scrollable.
   *
   * `large` - for size with an offset of `Header` height.
   *
   * `medium` - for size with an offset of `Header` with breadcrumbs height.
   *
   * `small` - for size with an offset of `Header` height and `SubHeader` height.
   *
   * `nano` - for size with an offset of `Header` with breadcrumbs height and `SubHeader` height.
   *
   * `viewport` - for Scrollable with viewport height.
   */
  size: PropTypes.oneOf(["nano", "small", "medium", "large", "viewport"]),
  /**
   * To provide external classNames.
   */
  className: PropTypes.string,
};

export default Scrollable;
